// extracted by mini-css-extract-plugin
export default {"customLabelInput":"media-label-input_customLabelInput__i3StX"};